<template>
    <component
        v-if="canSeePreviousOrderSummary"
        :is="element"
        :href="href"
        :class="[
            element === 'a'
                ? 'hover:bg-gray-50 focus:outline-none'
                : 'cursor-default',
            'inline-flex justify-center items-center w-full mt-3 px-3 py-3 rounded-md text-sm font-medium bg-white text-nutreance-green border-2 border-nutreance-green flex-wrap',
        ]"
    >
        <LoadingIcon v-if="loading" class="h-6 w-6 mr-2" />
        <UserIcon v-else class="h-6 w-6 mr-2" aria-hidden="true" />

        <span class="text-xl text-center">
            {{ loading ? "Searching for Previous Orders..." : description }}
        </span>
    </component>
</template>

<script setup lang="ts">
import { computed, ref } from "vue";
import { UserIcon } from "@heroicons/vue/solid";
import LoadingIcon from "../LoadingIcon.vue";
import { getPreviousOrderSummary } from "../../api/orders";

const props = defineProps<{
    csrf?: string;
    publicOrderId: string;
    canSeePreviousOrderSummary?: string;
}>();

const previousOrderSummary = ref<any>({});
const quantity = ref(0);

const loading = computed(() => _.isEmpty(previousOrderSummary.value));
const element = computed(() => (quantity.value > 0 ? "a" : "span"));
const href = computed(() =>
    element.value === "a" ? `/user/orders/${props.publicOrderId}/matches` : "",
);
const description = computed(() => {
    const units =
        quantity.value > 1 || quantity.value === 0 ? "Orders" : "Order";

    return quantity.value > 0
        ? `${quantity.value} Previous ${units} ($${previousOrderSummary.value.amount})`
        : `No Previous ${units}`;
});

if (props.canSeePreviousOrderSummary) {
    getPreviousOrderSummary(props.publicOrderId).then((data) => {
        previousOrderSummary.value = data.previousOrderSummary;

        if (
            Object.prototype.hasOwnProperty.call(
                previousOrderSummary.value,
                "quantity",
            )
        ) {
            quantity.value = data.previousOrderSummary.quantity;
        }
    });
}
</script>
